<template>
  <div></div>
</template>

<script>
import { authService } from "../services/auth.service";

export default {
  data() {
    return {
      value: ""
    };
  },
  created() {
    // reset login status
    this.logout();
  },
  methods: {
    logout() {
      authService
        .logout()
        .then(() => {
          window.location.href = process.env.VUE_APP_SSO_LOGOUT_URL;
        })
        .catch(err => {
          console.error(err);
          window.location.href = process.env.VUE_APP_SSO_LOGOUT_URL;
        });
    }
  }
};
</script>
